import dayjs from 'dayjs';
import { ICustomer } from 'app/shared/model/customer.model';
import { IContact } from 'app/shared/model/contact.model';
import { DocumentType } from 'app/shared/model/enumerations/document-type.model';
import { SigningSessionStatus } from 'app/shared/model/enumerations/signing-session-status.model';

export interface ISigningSession {
  id?: number;
  uuid?: string;
  documentType?: keyof typeof DocumentType;
  documentReferenceId?: number | null;
  documentPath?: string | null;
  signedDocumentPath?: string | null;
  documentHash?: string | null;
  status?: keyof typeof SigningSessionStatus;
  createdAt?: dayjs.Dayjs;
  updatedAt?: dayjs.Dayjs | null;
  customer?: ICustomer | null;
  contact?: IContact | null;
}

export const defaultValue: Readonly<ISigningSession> = {};
